module.exports = {
  "basic000": {
    "css": "--basic-000",
    "value": "#ffffff"
  },
  "basic100": {
    "css": "--basic-100",
    "value": "#fafafa"
  },
  "basic200": {
    "css": "--basic-200",
    "value": "#f2f4f5"
  },
  "basic300": {
    "css": "--basic-300",
    "value": "#e8eaeb"
  },
  "basic400": {
    "css": "--basic-400",
    "value": "#d7dbde"
  },
  "basic500": {
    "css": "--basic-500",
    "value": "#aeb3b8"
  },
  "basic600": {
    "css": "--basic-600",
    "value": "#6f767d"
  },
  "basic700": {
    "css": "--basic-700",
    "value": "#475059"
  },
  "basic800": {
    "css": "--basic-800",
    "value": "#202830"
  },
  "basic900": {
    "css": "--basic-900",
    "value": "#07111b"
  },
  "blue200": {
    "css": "--blue-200",
    "value": "#edf4fc"
  },
  "blue300": {
    "css": "--blue-300",
    "value": "#e3edfa"
  },
  "blue400": {
    "css": "--blue-400",
    "value": "#b8d0f2"
  },
  "blue500": {
    "css": "--blue-500",
    "value": "#1e7bfc"
  },
  "blue600": {
    "css": "--blue-600",
    "value": "#005cde"
  },
  "blue700": {
    "css": "--blue-700",
    "value": "#003fbd"
  },
  "blue800": {
    "css": "--blue-800",
    "value": "#001597"
  },
  "blue900": {
    "css": "--blue-900",
    "value": "#000079"
  },
  "green200": {
    "css": "--green-200",
    "value": "#ecf8f4"
  },
  "green300": {
    "css": "--green-300",
    "value": "#e3f5ef"
  },
  "green400": {
    "css": "--green-400",
    "value": "#bae7d8"
  },
  "green500": {
    "css": "--green-500",
    "value": "#1fc78f"
  },
  "green600": {
    "css": "--green-600",
    "value": "#00a870"
  },
  "green700": {
    "css": "--green-700",
    "value": "#00874f"
  },
  "green800": {
    "css": "--green-800",
    "value": "#006130"
  },
  "green900": {
    "css": "--green-900",
    "value": "#00430b"
  },
  "midnight200": {
    "css": "--midnight-200",
    "value": "#f2f3f5"
  },
  "midnight300": {
    "css": "--midnight-300",
    "value": "#e8eaed"
  },
  "midnight400": {
    "css": "--midnight-400",
    "value": "#d5dae6"
  },
  "midnight500": {
    "css": "--midnight-500",
    "value": "#a1acc9"
  },
  "midnight600": {
    "css": "--midnight-600",
    "value": "#677291"
  },
  "midnight700": {
    "css": "--midnight-700",
    "value": "#3e4966"
  },
  "midnight800": {
    "css": "--midnight-800",
    "value": "#172241"
  },
  "midnight900": {
    "css": "--midnight-900",
    "value": "#000921"
  },
  "orange200": {
    "css": "--orange-200",
    "value": "#fff4ed"
  },
  "orange300": {
    "css": "--orange-300",
    "value": "#ffeee3"
  },
  "orange400": {
    "css": "--orange-400",
    "value": "#ffd4ba"
  },
  "orange500": {
    "css": "--orange-500",
    "value": "#ff821f"
  },
  "orange600": {
    "css": "--orange-600",
    "value": "#ff6300"
  },
  "orange700": {
    "css": "--orange-700",
    "value": "#de4a00"
  },
  "orange800": {
    "css": "--orange-800",
    "value": "#b81c00"
  },
  "orange900": {
    "css": "--orange-900",
    "value": "#9a0000"
  },
  "purple200": {
    "css": "--purple-200",
    "value": "#f8f5fb"
  },
  "purple300": {
    "css": "--purple-300",
    "value": "#f1edf8"
  },
  "purple400": {
    "css": "--purple-400",
    "value": "#d3c4ed"
  },
  "purple500": {
    "css": "--purple-500",
    "value": "#8635f2"
  },
  "purple600": {
    "css": "--purple-600",
    "value": "#3e048b"
  },
  "purple700": {
    "css": "--purple-700",
    "value": "#28025a"
  },
  "purple800": {
    "css": "--purple-800",
    "value": "#1c0140"
  },
  "purple900": {
    "css": "--purple-900",
    "value": "#0a0113"
  },
  "red200": {
    "css": "--red-200",
    "value": "#fff1f0"
  },
  "red300": {
    "css": "--red-300",
    "value": "#ffeae8"
  },
  "red400": {
    "css": "--red-400",
    "value": "#ffcdc9"
  },
  "red500": {
    "css": "--red-500",
    "value": "#ff6459"
  },
  "red600": {
    "css": "--red-600",
    "value": "#ff4538"
  },
  "red700": {
    "css": "--red-700",
    "value": "#db362a"
  },
  "red800": {
    "css": "--red-800",
    "value": "#b80c00"
  },
  "red900": {
    "css": "--red-900",
    "value": "#9a0a00"
  },
  "teal200": {
    "css": "--teal-200",
    "value": "#f0f9fa"
  },
  "teal300": {
    "css": "--teal-300",
    "value": "#ebf9fa"
  },
  "teal400": {
    "css": "--teal-400",
    "value": "#ceeef0"
  },
  "teal500": {
    "css": "--teal-500",
    "value": "#6ae2e8"
  },
  "teal600": {
    "css": "--teal-600",
    "value": "#4bc3c9"
  },
  "teal700": {
    "css": "--teal-700",
    "value": "#2aa2a8"
  },
  "teal800": {
    "css": "--teal-800",
    "value": "#047c82"
  },
  "teal900": {
    "css": "--teal-900",
    "value": "#005e64"
  },
  "yellow200": {
    "css": "--yellow-200",
    "value": "#fffbf2"
  },
  "yellow300": {
    "css": "--yellow-300",
    "value": "#fff6e3"
  },
  "yellow400": {
    "css": "--yellow-400",
    "value": "#ffeecc"
  },
  "yellow500": {
    "css": "--yellow-500",
    "value": "#ffe16b"
  },
  "yellow600": {
    "css": "--yellow-600",
    "value": "#ffc847"
  },
  "yellow700": {
    "css": "--yellow-700",
    "value": "#eda813"
  },
  "yellow800": {
    "css": "--yellow-800",
    "value": "#bf8300"
  },
  "yellow900": {
    "css": "--yellow-900",
    "value": "#996800"
  },
  "primary200": {
    "css": "--primary-200",
    "value": "var(--basic-200)"
  },
  "primary300": {
    "css": "--primary-300",
    "value": "var(--basic-300)"
  },
  "primary400": {
    "css": "--primary-400",
    "value": "var(--basic-400)"
  },
  "primary500": {
    "css": "--primary-500",
    "value": "var(--basic-500)"
  },
  "primary600": {
    "css": "--primary-600",
    "value": "var(--basic-600)"
  },
  "primary700": {
    "css": "--primary-700",
    "value": "var(--basic-700)"
  },
  "primary800": {
    "css": "--primary-800",
    "value": "var(--basic-800)"
  },
  "primary900": {
    "css": "--primary-900",
    "value": "var(--basic-900)"
  },
  "secondary200": {
    "css": "--secondary-200",
    "value": "var(--purple-200)"
  },
  "secondary300": {
    "css": "--secondary-300",
    "value": "var(--purple-300)"
  },
  "secondary400": {
    "css": "--secondary-400",
    "value": "var(--purple-400)"
  },
  "secondary500": {
    "css": "--secondary-500",
    "value": "var(--purple-500)"
  },
  "secondary600": {
    "css": "--secondary-600",
    "value": "var(--purple-600)"
  },
  "secondary700": {
    "css": "--secondary-700",
    "value": "var(--purple-700)"
  },
  "secondary800": {
    "css": "--secondary-800",
    "value": "var(--purple-800)"
  },
  "secondary900": {
    "css": "--secondary-900",
    "value": "var(--purple-900)"
  },
  "info200": {
    "css": "--info-200",
    "value": "var(--blue-200)"
  },
  "info300": {
    "css": "--info-300",
    "value": "var(--blue-300)"
  },
  "info400": {
    "css": "--info-400",
    "value": "var(--blue-400)"
  },
  "info500": {
    "css": "--info-500",
    "value": "var(--blue-500)"
  },
  "info600": {
    "css": "--info-600",
    "value": "var(--blue-600)"
  },
  "info700": {
    "css": "--info-700",
    "value": "var(--blue-700)"
  },
  "info800": {
    "css": "--info-800",
    "value": "var(--blue-800)"
  },
  "info900": {
    "css": "--info-900",
    "value": "var(--blue-900)"
  },
  "error200": {
    "css": "--error-200",
    "value": "var(--red-200)"
  },
  "error300": {
    "css": "--error-300",
    "value": "var(--red-300)"
  },
  "error400": {
    "css": "--error-400",
    "value": "var(--red-400)"
  },
  "error500": {
    "css": "--error-500",
    "value": "var(--red-500)"
  },
  "error600": {
    "css": "--error-600",
    "value": "var(--red-600)"
  },
  "error700": {
    "css": "--error-700",
    "value": "var(--red-700)"
  },
  "error800": {
    "css": "--error-800",
    "value": "var(--red-800)"
  },
  "error900": {
    "css": "--error-900",
    "value": "var(--red-900)"
  },
  "success200": {
    "css": "--success-200",
    "value": "var(--green-200)"
  },
  "success300": {
    "css": "--success-300",
    "value": "var(--green-300)"
  },
  "success400": {
    "css": "--success-400",
    "value": "var(--green-400)"
  },
  "success500": {
    "css": "--success-500",
    "value": "var(--green-500)"
  },
  "success600": {
    "css": "--success-600",
    "value": "var(--green-600)"
  },
  "success700": {
    "css": "--success-700",
    "value": "var(--green-700)"
  },
  "success800": {
    "css": "--success-800",
    "value": "var(--green-800)"
  },
  "success900": {
    "css": "--success-900",
    "value": "var(--green-900)"
  },
  "warning200": {
    "css": "--warning-200",
    "value": "var(--yellow-200)"
  },
  "warning300": {
    "css": "--warning-300",
    "value": "var(--yellow-300)"
  },
  "warning400": {
    "css": "--warning-400",
    "value": "var(--yellow-400)"
  },
  "warning500": {
    "css": "--warning-500",
    "value": "var(--yellow-500)"
  },
  "warning600": {
    "css": "--warning-600",
    "value": "var(--yellow-600)"
  },
  "warning700": {
    "css": "--warning-700",
    "value": "var(--yellow-700)"
  },
  "warning800": {
    "css": "--warning-800",
    "value": "var(--yellow-800)"
  },
  "warning900": {
    "css": "--warning-900",
    "value": "var(--yellow-900)"
  },
  "backgroundColor": {
    "css": "--background-color",
    "value": "var(--basic-000)"
  },
  "workspacePrimary600": {
    "css": "--workspace-primary-600",
    "value": "var(--primary-600)"
  },
  "workspacePrimary700": {
    "css": "--workspace-primary-700",
    "value": "var(--primary-700)"
  },
  "workspacePrimary800": {
    "css": "--workspace-primary-800",
    "value": "var(--primary-800)"
  },
  "workspaceSecondary100": {
    "css": "--workspace-secondary-100",
    "value": "var(--secondary-100)"
  },
  "workspaceSecondary150": {
    "css": "--workspace-secondary-150",
    "value": "var(--secondary-100)"
  },
  "workspaceSecondary200": {
    "css": "--workspace-secondary-200",
    "value": "var(--secondary-200)"
  },
  "workspaceSecondary300": {
    "css": "--workspace-secondary-300",
    "value": "var(--secondary-300)"
  },
  "workspaceSecondary800": {
    "css": "--workspace-secondary-800",
    "value": "var(--secondary-800)"
  },
  "workspaceWhite": {
    "css": "--workspace-white",
    "value": "hsla(\n    0deg,\n    0%,\n    100%,\n    var(--opacity, 100%)\n  )"
  },
  "overlayWhite25": {
    "css": "--overlay-white-25",
    "value": "hsla(\n    0deg,\n    0%,\n    100%,\n    var(--opacity, 25%)\n  )"
  },
  "overlayDark50": {
    "css": "--overlay-dark-50",
    "value": "hsla(\n    210deg,\n    20%,\n    15.6862745098%,\n    var(--opacity, 50%)\n  )"
  },
  "white": {
    "css": "--white",
    "value": "var(--basic-000)"
  },
  "black": {
    "css": "--black",
    "value": "var(--basic-900)"
  },
  "neutral100": {
    "css": "--neutral-100",
    "value": "var(--basic-100)"
  },
  "neutral150": {
    "css": "--neutral-150",
    "value": "var(--basic-100)"
  },
  "neutral200": {
    "css": "--neutral-200",
    "value": "var(--basic-200)"
  },
  "neutral300": {
    "css": "--neutral-300",
    "value": "var(--basic-300)"
  },
  "neutral800": {
    "css": "--neutral-800",
    "value": "var(--basic-800)"
  },
  "gray100": {
    "css": "--gray-100",
    "value": "var(--basic-100)"
  },
  "gray200": {
    "css": "--gray-200",
    "value": "var(--basic-200)"
  },
  "gray300": {
    "css": "--gray-300",
    "value": "var(--basic-300)"
  },
  "gray400": {
    "css": "--gray-400",
    "value": "var(--basic-400)"
  },
  "gray500": {
    "css": "--gray-500",
    "value": "var(--basic-500)"
  },
  "gray600": {
    "css": "--gray-600",
    "value": "var(--basic-600)"
  },
  "gray700": {
    "css": "--gray-700",
    "value": "var(--basic-700)"
  },
  "gray800": {
    "css": "--gray-800",
    "value": "var(--basic-800)"
  },
  "gray900": {
    "css": "--gray-900",
    "value": "var(--basic-900)"
  },
  "midnight100": {
    "css": "--midnight-100",
    "value": "var(--basic-100)"
  },
  "brand100": {
    "css": "--brand-100",
    "value": "var(--basic-100)"
  },
  "brand200": {
    "css": "--brand-200",
    "value": "var(--primary-200)"
  },
  "brand300": {
    "css": "--brand-300",
    "value": "var(--primary-300)"
  },
  "brand400": {
    "css": "--brand-400",
    "value": "var(--primary-400)"
  },
  "brand500": {
    "css": "--brand-500",
    "value": "var(--primary-500)"
  },
  "brand600": {
    "css": "--brand-600",
    "value": "var(--primary-600)"
  },
  "brand700": {
    "css": "--brand-700",
    "value": "var(--primary-700)"
  },
  "brand800": {
    "css": "--brand-800",
    "value": "var(--primary-800)"
  },
  "brand900": {
    "css": "--brand-900",
    "value": "var(--primary-900)"
  },
  "feature200": {
    "css": "--feature-200",
    "value": "var(--purple-200)"
  },
  "feature300": {
    "css": "--feature-300",
    "value": "var(--purple-300)"
  },
  "feature400": {
    "css": "--feature-400",
    "value": "var(--purple-400)"
  },
  "feature500": {
    "css": "--feature-500",
    "value": "var(--purple-500)"
  },
  "feature600": {
    "css": "--feature-600",
    "value": "var(--purple-600)"
  },
  "feature700": {
    "css": "--feature-700",
    "value": "var(--purple-700)"
  },
  "feature800": {
    "css": "--feature-800",
    "value": "var(--purple-800)"
  },
  "feature900": {
    "css": "--feature-900",
    "value": "var(--purple-900)"
  },
  "tertiary200": {
    "css": "--tertiary-200",
    "value": "var(--teal-200)"
  },
  "tertiary300": {
    "css": "--tertiary-300",
    "value": "var(--teal-300)"
  },
  "tertiary400": {
    "css": "--tertiary-400",
    "value": "var(--teal-400)"
  },
  "tertiary500": {
    "css": "--tertiary-500",
    "value": "var(--teal-500)"
  },
  "tertiary600": {
    "css": "--tertiary-600",
    "value": "var(--teal-600)"
  },
  "tertiary700": {
    "css": "--tertiary-700",
    "value": "var(--teal-700)"
  },
  "tertiary800": {
    "css": "--tertiary-800",
    "value": "var(--teal-800)"
  },
  "tertiary900": {
    "css": "--tertiary-900",
    "value": "var(--teal-900)"
  },
  "fontSizeSmall": {
    "css": "--font-size-small",
    "value": "12px"
  },
  "fontSizeMedium": {
    "css": "--font-size-medium",
    "value": "14px"
  },
  "fontSizeLarge": {
    "css": "--font-size-large",
    "value": "16px"
  },
  "fontSizeXlarge": {
    "css": "--font-size-xlarge",
    "value": "18px"
  },
  "fontSizeMega": {
    "css": "--font-size-mega",
    "value": "20px"
  },
  "fontSizeXmega": {
    "css": "--font-size-xmega",
    "value": "22px"
  },
  "fontSizeGiga": {
    "css": "--font-size-giga",
    "value": "24px"
  },
  "fontSizeXgiga": {
    "css": "--font-size-xgiga",
    "value": "28px"
  },
  "fontSizeTera": {
    "css": "--font-size-tera",
    "value": "32px"
  },
  "fontSizeXtera": {
    "css": "--font-size-xtera",
    "value": "40px"
  },
  "fontWeightBold": {
    "css": "--font-weight-bold",
    "value": "700"
  },
  "fontWeightMedium": {
    "css": "--font-weight-medium",
    "value": "500"
  },
  "fontWeightRegular": {
    "css": "--font-weight-regular",
    "value": "400"
  },
  "fontWeightLight": {
    "css": "--font-weight-light",
    "value": "300"
  },
  "fontFamilyBase": {
    "css": "--font-family-base",
    "value": "\"Roboto\""
  },
  "fontFamilyFallbacks": {
    "css": "--font-family-fallbacks",
    "value": "-apple-system, BlinkMacSystemFont, \"Segoe UI\",\n    Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\",\n    \"Segoe UI Symbol\""
  },
  "fontFamily": {
    "css": "--font-family",
    "value": "var(--font-family-base), var(--font-family-fallbacks)"
  },
  "fontSizeTiny": {
    "css": "--font-size-tiny",
    "value": "10px"
  },
  "fontSizeBase": {
    "css": "--font-size-base",
    "value": "var(--font-size-medium)"
  },
  "zIndex100": {
    "css": "--z-index-100",
    "value": "1100"
  },
  "zIndex200": {
    "css": "--z-index-200",
    "value": "1200"
  },
  "zIndex300": {
    "css": "--z-index-300",
    "value": "1300"
  },
  "zIndex400": {
    "css": "--z-index-400",
    "value": "1400"
  },
  "zIndex500": {
    "css": "--z-index-500",
    "value": "1500"
  },
  "zIndex600": {
    "css": "--z-index-600",
    "value": "1600"
  },
  "zIndex700": {
    "css": "--z-index-700",
    "value": "1700"
  },
  "borderRadiusXsmall": {
    "css": "--border-radius-xsmall",
    "value": "4px"
  },
  "borderRadiusSmall": {
    "css": "--border-radius-small",
    "value": "8px"
  },
  "borderRadiusMedium": {
    "css": "--border-radius-medium",
    "value": "16px"
  },
  "borderRadiusLarge": {
    "css": "--border-radius-large",
    "value": "24px"
  },
  "borderRadiusPill": {
    "css": "--border-radius-pill",
    "value": "500px"
  },
  "borderRadiusCircular": {
    "css": "--border-radius-circular",
    "value": "50%"
  },
  "borderWidthNone": {
    "css": "--border-width-none",
    "value": "0"
  },
  "borderWidthHairline": {
    "css": "--border-width-hairline",
    "value": "1px"
  },
  "borderWidthThin": {
    "css": "--border-width-thin",
    "value": "2px"
  },
  "borderWidthThick": {
    "css": "--border-width-thick",
    "value": "4px"
  },
  "borderWidthHeavy": {
    "css": "--border-width-heavy",
    "value": "8px"
  },
  "opacityOpaque": {
    "css": "--opacity-opaque",
    "value": "1"
  },
  "opacitySemiopaque": {
    "css": "--opacity-semiopaque",
    "value": "0.8"
  },
  "opacityIntense": {
    "css": "--opacity-intense",
    "value": "0.56"
  },
  "opacityMedium": {
    "css": "--opacity-medium",
    "value": "0.4"
  },
  "opacityLight": {
    "css": "--opacity-light",
    "value": "0.16"
  },
  "opacitySemitransparent": {
    "css": "--opacity-semitransparent",
    "value": "0.08"
  },
  "opacityTransparent": {
    "css": "--opacity-transparent",
    "value": "0"
  },
  "shadowLevel1": {
    "css": "--shadow-level-1",
    "value": "0 1px 2px"
  },
  "shadowLevel2": {
    "css": "--shadow-level-2",
    "value": "0 2px 6px"
  },
  "shadowLevel3": {
    "css": "--shadow-level-3",
    "value": "0 4px 12px"
  },
  "shadowLevel4": {
    "css": "--shadow-level-4",
    "value": "0 8px 20px"
  },
  "spacingInsetNano": {
    "css": "--spacing-inset-nano",
    "value": "4px"
  },
  "spacingInsetMicro": {
    "css": "--spacing-inset-micro",
    "value": "8px"
  },
  "spacingInsetXsmall": {
    "css": "--spacing-inset-xsmall",
    "value": "12px"
  },
  "spacingInsetSmall": {
    "css": "--spacing-inset-small",
    "value": "16px"
  },
  "spacingInsetMedium": {
    "css": "--spacing-inset-medium",
    "value": "20px"
  },
  "spacingInsetLarge": {
    "css": "--spacing-inset-large",
    "value": "24px"
  },
  "spacingInsetXlarge": {
    "css": "--spacing-inset-xlarge",
    "value": "32px"
  },
  "spacingInsetMega": {
    "css": "--spacing-inset-mega",
    "value": "40px"
  },
  "spacingInsetXmega": {
    "css": "--spacing-inset-xmega",
    "value": "48px"
  },
  "baseSpacing": {
    "css": "--base-spacing",
    "value": "var(--spacing-inset-nano)"
  },
  "baseSpacing0": {
    "css": "--base-spacing-0",
    "value": "0"
  },
  "baseSpacing1": {
    "css": "--base-spacing-1",
    "value": "var(--base-spacing)"
  },
  "baseSpacing2": {
    "css": "--base-spacing-2",
    "value": "calc(var(--base-spacing) * 2)"
  },
  "baseSpacing3": {
    "css": "--base-spacing-3",
    "value": "calc(var(--base-spacing) * 3)"
  },
  "baseSpacing4": {
    "css": "--base-spacing-4",
    "value": "calc(var(--base-spacing) * 4)"
  },
  "baseSpacing5": {
    "css": "--base-spacing-5",
    "value": "calc(var(--base-spacing) * 5)"
  },
  "baseSpacing6": {
    "css": "--base-spacing-6",
    "value": "calc(var(--base-spacing) * 6)"
  },
  "baseSpacing7": {
    "css": "--base-spacing-7",
    "value": "calc(var(--base-spacing) * 7)"
  },
  "baseSpacing8": {
    "css": "--base-spacing-8",
    "value": "calc(var(--base-spacing) * 8)"
  },
  "baseSpacing9": {
    "css": "--base-spacing-9",
    "value": "calc(var(--base-spacing) * 9)"
  },
  "baseSpacing10": {
    "css": "--base-spacing-10",
    "value": "calc(var(--base-spacing) * 10)"
  },
  "baseSpacing11": {
    "css": "--base-spacing-11",
    "value": "calc(var(--base-spacing) * 11)"
  },
  "baseSpacing12": {
    "css": "--base-spacing-12",
    "value": "calc(var(--base-spacing) * 12)"
  },
  "cdnBaseUrl": {
    "css": "--cdn-base-url",
    "value": "\"https://prd-cdn-talkdesk.talkdesk.com\""
  }
};